import { notification } from "antd";
import type { RpcError } from "grpc-web";

import history from "../history";
import SessionStore from "./SessionStore";

export function HandleError(e: RpcError) {
  console.log("API error: ", e);

  if (e.code === 16 || e.code === 2) {
    // Authentication/authorization error - attempt session recovery first
    console.log("Authentication error detected, attempting session recovery...");
    
    // Check if we have a token and attempt recovery
    const token = SessionStore.getToken();
    if (token) {
      // Attempt to refresh the session before redirecting to login
      SessionStore.refreshSession();
      
      // Give a short delay to allow session recovery, then check if user is still logged in
      setTimeout(() => {
        const user = SessionStore.getUser();
        if (!user) {
          console.log("Session recovery failed, redirecting to login");
          history.push("/login");
        } else {
          console.log("Session recovery successful, user still logged in");
        }
      }, 1000); // Wait 1 second for session recovery
    } else {
      // No token available, redirect to login immediately
      console.log("No token available, redirecting to login");
      history.push("/login");
    }
    return;
  }

  // Error notifications disabled
  // notification.error({
  //   message: "Error",
  //   description: e.message,
  //   duration: 3,
  // });
}

export function HandleLoginError(e: RpcError) {
  console.log("API error: ", e);
  // Error notifications disabled
  // notification.error({
  //   message: "Error",
  //   description: e.message,
  //   duration: 3,
  // });
}

// Enhanced error handler with session recovery for store methods
export function HandleErrorWithRetry<T>(
  e: RpcError,
  retryFunction: () => void,
  maxRetries: number = 1
) {
  console.log("API error with retry: ", e);

  if (e.code === 16 || e.code === 2) {
    // Authentication/authorization error - attempt session recovery first
    console.log("Authentication error detected, attempting session recovery...");
    
    // Check if we have a token and attempt recovery
    const token = SessionStore.getToken();
    if (token) {
      // Attempt to refresh the session before redirecting to login
      SessionStore.refreshSession();
      
      // Give a short delay to allow session recovery, then retry the function
      setTimeout(() => {
        const user = SessionStore.getUser();
        if (user && maxRetries > 0) {
          console.log("Session recovery successful, retrying function");
          retryFunction();
        } else {
          console.log("Session recovery failed or max retries exceeded, redirecting to login");
          history.push("/login");
        }
      }, 1500); // Wait 1.5 seconds for session recovery
    } else {
      // No token available, redirect to login immediately
      console.log("No token available, redirecting to login");
      history.push("/login");
    }
    return;
  }

  // For non-authentication errors, use the standard error handler
  HandleError(e);
}
